var timerFunction;
/* eslint @typescript-eslint/ban-types: 0  */
export function debounce(callback, time) {
    clearTimeout(timerFunction);
    timerFunction = setTimeout(callback, time);
}
